import { AC_METER_READING_REPORT } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  acMeterReadingReport: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const acMeterReadingReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AC_METER_READING_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }
    case AC_METER_READING_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        acMeterReadingReport: payload,
      };
    }

    case AC_METER_READING_REPORT.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default acMeterReadingReportReducer;
